export const styles = {
  grid: {
    display: 'grid',
    grid: 'auto / 1fr 1fr 1fr',
    rowGap: 24,
    columnGap: 16,
  },
};
